/**
 * Encaptulates functionality to store and retrieve FRP data from the data store
 */
import { VersionedObjectPersistence } from "src/common/managers/ESVersionedPersistance";
import { FRPElement, FRPElementPersistenceInterface } from "./FRPState";

export class FRPElementPersistence extends VersionedObjectPersistence<FRPElement> implements FRPElementPersistenceInterface {

   static instance: FRPElementPersistence;

   static setInstance(instance: FRPElementPersistence) {
      FRPElementPersistence.instance = instance;
   }

   static getInstance(): FRPElementPersistence {
      if (!FRPElementPersistence.instance) {
         throw new Error("FRPElementPersistence not initialized");
      }
      return FRPElementPersistence.instance;
   }

   private static indexMappings =
      {
         "properties": {
         }
      }
   private static idGetter = (object) => { return object.id; }

   constructor(objectsESIndexName: string, userId: string) {

      super(objectsESIndexName, userId, {}, FRPElementPersistence.idGetter)

   }

}
